var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindow1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "window_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "window_1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(57.000000, 23.000000)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "0 0 8 3.1175818 8 66.9478302 0 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "12 0 20 3.1175818 20 66.9478302 12 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "12 0 20 3.1175818 20 66.9478302 12 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "25 0 33 3.1175818 33 66.9478302 25 64.0551069"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#4A4A4A",
    transform: "translate(4.000000, 33.473915) scale(-1, 1) translate(-4.000000, -33.473915) ",
    points: "0 0 8 3.1175818 8 66.9478302 0 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#D8D8D8",
    transform: "translate(16.000000, 33.473915) scale(-1, 1) translate(-16.000000, -33.473915) ",
    points: "12 0 20 3.1175818 20 66.9478302 12 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#D8D8D8",
    transform: "translate(16.000000, 33.473915) scale(-1, 1) translate(-16.000000, -33.473915) ",
    points: "12 0 20 3.1175818 20 66.9478302 12 64.0551069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#D8D8D8",
    transform: "translate(29.000000, 33.473915) scale(-1, 1) translate(-29.000000, -33.473915) ",
    points: "25 0 33 3.1175818 33 66.9478302 25 64.0551069"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 10,
    y: 16,
    width: 80,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4A4A4A",
    x: 10,
    y: 16,
    width: 80,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow1);
export default __webpack_public_path__ + "static/media/window_1.2698309ed8dad547619540fd4d1a8bfb.svg";
export { ForwardRef as ReactComponent };